import React, { PropsWithChildren } from 'react';

import clsxm from '@/lib/clsxm';

export type CardProps = PropsWithChildren<{
  className?: string;
}>;

const ElevatedCard: React.FC<CardProps> = ({ children, className }) => {
  return (
    <div
      className={clsxm(
        'mx-2 mb-[5px] rounded-2xl bg-white text-s shadow-sm',
        className
      )}
    >
      {children}
    </div>
  );
};

export default ElevatedCard;
